module.exports = __webpack_public_path__ + "static/media/car-bump.1e85fbfb.svg";